
import React, { useState, useEffect } from 'react'
import { Checkbox, Col, Row, Tooltip } from 'antd'
import { useDispatch, useSelector } from 'react-redux';
import {
    setSelectedStops,
    setSelectedReturnStops,
    setSelectedDeparture,
    setSelectedReturnDate,
    setSelectedAirlines,
    setSelectedReturnAirlines,
    setPriceRange,
    setReturnPriceRange,
    setDefaultPriceRange,
    clearAllFiltersRoundTrip,
    setSortBy,
    setSortByReturn,
    applyFilters
} from '../../../redux/flight/flightRoundTripFilterSlice';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { FaRupeeSign, FaTimes } from 'react-icons/fa';

const RoundTripFilter = ({
    setIsVisibleRoundTrip,
    setArrivalDataReturn,
    setDepartureData,
    setSelectedValueReturn,
    setSelectedValue,
    setShouldLoadOnward,
    setShouldLoadReturn
}) => {

    const roundCityFlightFilterData = useSelector((state) => state.flightRoundCity.roundCityFlightFilterData);
    const minPrice = roundCityFlightFilterData?.priceRange?.minPrice || 0;
    const maxPrice = roundCityFlightFilterData?.priceRange?.maxPrice || 100;
    const returnMinPrice = roundCityFlightFilterData?.returnPriceRange?.minPrice || 0;
    const returnMaxPrice = roundCityFlightFilterData?.returnPriceRange?.maxPrice || 100;
    const [selectedSort, setSelectedSort] = useState("cheapest");
    const [selectedSortReturn, setSelectedSortReturn] = useState("cheapestReturn");

    const [isMobile, setIsMobile] = useState(true);
    const { selectedStops, selectedReturnStops, selectedDeparture, selectedReturnDate, selectedAirlines, selectedReturnAirlines, priceRange, returnPriceRange, sortByReturn } = useSelector((state) => state.flightFilterRoundTrip);
    const dispatch = useDispatch();


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // Adjust this value according to your mobile screen width
        };
        handleResize(); // Call it initially to check the screen width
        window.addEventListener('resize', handleResize); // Listen for window resize events
        return () => {
            window.removeEventListener('resize', handleResize); // Cleanup
        };
    }, []);



    const handleStopChange = (event) => {
        const { id, checked } = event.target;
        const updatedStops = checked
            ? [...selectedStops, id]
            : selectedStops.filter((stop) => stop !== id);
        setSelectedValue(0);
        dispatch(setSelectedStops(updatedStops));
        setShouldLoadOnward(false)
    };

    const filteredDataRoundTrip = useSelector((state) => state.flightFilterRoundTrip.filteredDataRoundTrip);

    const handleReturnStopChange = (event) => {
        const { value, checked } = event.target;
        const updatedReturnStops = checked
            ? [...selectedReturnStops, value]
            : selectedReturnStops.filter((stop) => stop !== value);
        setSelectedValueReturn(0)
        dispatch(setSelectedReturnStops(updatedReturnStops));
        localStorage.removeItem("selectedSortReturn");
        setShouldLoadReturn(false)
    };

    const handleDepartureTimeChange = (event) => {
        const { id, checked } = event.target;
        const updatedDeparture = checked
            ? [...selectedDeparture, id]
            : selectedDeparture.filter((time) => time !== id);
        setSelectedValue(0);
        dispatch(setSelectedDeparture(updatedDeparture));
        localStorage.removeItem("selectedSortReturn");
        setShouldLoadOnward(false)
    };


    // Handle return date change
    const handleReturnDateChange = (event) => {
        const { value, checked } = event.target;
        const updatedReturnDate = checked
            ? [...selectedReturnDate, value]
            : selectedReturnDate.filter((time) => time !== value);
        setSelectedValueReturn(0)
        dispatch(setSelectedReturnDate(updatedReturnDate));
        localStorage.removeItem("selectedSortReturn");
        setShouldLoadReturn(false)
    };

    // Handle airline change
    const handleAirlineChange = (airline) => {
        const updatedAirlines = selectedAirlines.includes(airline)
            ? selectedAirlines.filter((item) => item !== airline)
            : [...selectedAirlines, airline];
        dispatch(setSelectedAirlines(updatedAirlines));
        dispatch(setSelectedReturnAirlines(updatedAirlines));
        localStorage.removeItem("selectedSortReturn");
        setShouldLoadOnward(false)
        setShouldLoadReturn(false)
    };

    const handleSortChange = (type) => {
        if (selectedSort !== type) {
            setSelectedSort(type);
            dispatch(setSortBy(type));
            setSelectedValue(0);
            localStorage.removeItem("selectedSortReturn");
            dispatch(applyFilters({ roundCityFlightFilterData }));
            setShouldLoadOnward(false)
        }
    };

    const handleSortReturnChange = (type) => {
        if (selectedSortReturn !== type) {
            setSelectedSortReturn(type);
            dispatch(setSortByReturn(type));
            setSelectedValueReturn(0)
            dispatch(applyFilters({ roundCityFlightFilterData }));
            localStorage.setItem("selectedSortReturn", type);
            setShouldLoadReturn(false)
        }
    };


    // Handle price range change
    const handlePriceRangeChange = (newValue) => {
        setSelectedValue(0);
        dispatch(setPriceRange(newValue));
        localStorage.removeItem("selectedSortReturn");
        setShouldLoadOnward(false)
    };

    // Handle return price range change
    const handleReturnPriceRangeChange = (newValue) => {
        dispatch(setReturnPriceRange(newValue));
        setSelectedValueReturn(0)
        setShouldLoadReturn(false)
    };

    // Clear all filters
    const handleClearFilters = () => {
        dispatch(clearAllFiltersRoundTrip({ roundCityFlightFilterData }));
        setSelectedSort("cheapest")
        setSelectedSortReturn("")
        localStorage.removeItem("selectedSortReturn");
        setArrivalDataReturn(null)
        setDepartureData(null)
        setSelectedValueReturn(0)
        setSelectedValue(0);
        setShouldLoadOnward(false)
    };

    // Apply filters
    useEffect(() => {
        dispatch(applyFilters({ roundCityFlightFilterData }));
    }, [
        selectedStops,
        selectedReturnStops,
        selectedDeparture,
        selectedReturnDate,
        selectedAirlines,
        selectedReturnAirlines,
        priceRange,
        returnPriceRange,
        roundCityFlightFilterData,
        dispatch,
    ]);

    useEffect(() => {
        if (roundCityFlightFilterData) {
            const minPrice = roundCityFlightFilterData?.priceRange?.minPrice || 0;
            const maxPrice = roundCityFlightFilterData?.priceRange?.maxPrice || 100;
            const returnMinPrice = roundCityFlightFilterData?.returnPriceRange?.minPrice || 0;
            const returnMaxPrice = roundCityFlightFilterData?.returnPriceRange?.maxPrice || 100;
            dispatch(setDefaultPriceRange([minPrice, maxPrice]));
            dispatch(setPriceRange([minPrice, maxPrice]));
            dispatch(setReturnPriceRange([returnMinPrice, returnMaxPrice]));
        }
    }, [roundCityFlightFilterData, dispatch]);

    const [showAll, setShowAll] = useState(false);
    const maxVisibleItems = 5;

    const toggleView = () => {
        setShowAll(!showAll);
    };

    const visibleAirlines = showAll ? roundCityFlightFilterData?.preferredAirlines : roundCityFlightFilterData?.preferredAirlines?.slice(0, maxVisibleItems);

    return (
        <>

            <div className="MobilefilterSearchcard filter-searchBar filterSearchcard bg-white rounded-3 mb-3 mb-md-4">
                <div className="filter-searchBar-head border-bottom w-100">
                    <div className="searchBar-headerBody d-flex align-items-center justify-content-between px-3 py-3">
                        <button onClick={() => setIsVisibleRoundTrip(false)} className='btn btn-light-primary border-0 rounded d-flex align-items-center p-1 d-md-none' aria-label="Close filter">
                            <FaTimes className='fs-3 text-primary' />
                        </button>
                        <div className="searchBar-headerfirst lh-sm text-center text-md-start">
                            <p className="fw-bold fs-5 m-0 lh-sm">Filters</p>
                            <p className="text-md text-muted m-0">Showing {filteredDataRoundTrip?.flights?.length + filteredDataRoundTrip?.returnFlights?.length} Flights</p>
                        </div>
                        <div className="searchBar-headerlast text-end d-flex gap-1">
                            <button className="btn btn-danger py-0 rounded read-more-button text-decoration-none" onClick={handleClearFilters} aria-label="clear all" >Clear All</button>
                        </div>
                    </div>
                </div>


                <div className="filter-searchBar-body pb-3">

                    <div className="searchBar-single px-3 py-3 border-bottom">
                        <div className="searchBar-single-title d-flex mb-3">
                            <h6 className="sidebar-subTitle fs-6 fw-medium m-0">Onward Stops</h6>
                        </div>
                        <div className="searchBar-single-wrap">
                            <Row gutter={16} className="align-items-center justify-content-between">
                                <Col xs={8} className='text-center pe-0'>
                                    <input
                                        type="checkbox"
                                        className="btn-check"
                                        id="0"
                                        onChange={handleStopChange}
                                        checked={selectedStops?.includes('0')}
                                    />
                                    <label className="btn rounded-left fw-medium full-width" htmlFor="0">
                                        Direct
                                    </label>
                                </Col>
                                <Col xs={8} className='text-center p-0'>
                                    <input
                                        type="checkbox"
                                        className="btn-check"
                                        id="1"
                                        onChange={handleStopChange}
                                        checked={selectedStops?.includes('1')}
                                    />
                                    <label className="btn rounded-0 fw-medium full-width" htmlFor="1">
                                        1 Stop
                                    </label>
                                </Col>
                                <Col xs={8} className='text-center ps-0'>
                                    <input
                                        type="checkbox"
                                        className="btn-check"
                                        id="2"
                                        onChange={handleStopChange}
                                        checked={selectedStops?.includes('2')}
                                    />
                                    <label className="btn rounded-right fw-medium full-width" htmlFor="2">
                                        2+ Stop
                                    </label>
                                </Col>
                            </Row>
                        </div>
                    </div>

                    {filteredDataRoundTrip?.checkFlightType !== "INTERNATIONAL" &&
                        <div className="searchBar-single px-3 py-3 border-bottom">
                            <div className="searchBar-single-title d-flex mb-3">
                                <h6 className="sidebar-subTitle fs-6 fw-medium m-0">Return Stops </h6>
                            </div>
                            <div className="searchBar-single-wrap">
                                <Row gutter={16} className="align-items-center justify-content-between">
                                    <Col xs={8} className='text-center pe-0'>
                                        <input
                                            type="checkbox"
                                            className="btn-check"
                                            id="Direct"
                                            value="0"
                                            onChange={handleReturnStopChange}
                                            checked={selectedReturnStops?.includes('0')}
                                        />
                                        <label className="btn rounded-left fw-medium full-width" htmlFor="Direct">
                                            Direct
                                        </label>
                                    </Col>
                                    <Col xs={8} className='text-center p-0'>
                                        <input
                                            type="checkbox"
                                            className="btn-check"
                                            id="1Stop"
                                            value="1"
                                            onChange={handleReturnStopChange}
                                            checked={selectedReturnStops?.includes('1')}
                                        />
                                        <label className="btn rounded-0 fw-medium full-width" htmlFor="1Stop">
                                            1 Stop
                                        </label>
                                    </Col>
                                    <Col xs={8} className='text-center ps-0'>
                                        <input
                                            type="checkbox"
                                            className="btn-check"
                                            id="2+Stop"
                                            value="2"
                                            onChange={handleReturnStopChange}
                                            checked={selectedReturnStops?.includes('2')}
                                        />
                                        <label className="btn rounded-right fw-medium full-width" htmlFor="2+Stop">
                                            2+ Stop
                                        </label>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    }


                    <div className="searchBar-single px-3 py-3 border-bottom">
                        <div className="searchBar-single-title d-flex mb-3">
                            <h6 className="sidebar-subTitle fs-6 fw-medium m-0">Departure Popular Filter</h6>
                        </div>
                        <div className="searchBar-single-wrap">
                            <Row gutter={16} className="align-items-center justify-content-between">
                                <Col xs={12} className="text-center pe-0">
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        id="cheapest"
                                        checked={selectedSort === "cheapest"}
                                        onChange={() => handleSortChange("cheapest")}
                                    />
                                    <label
                                        className="btn btn-sm rounded-left fw-medium full-width d-flex align-items-center justify-content-center gap-1"
                                        htmlFor="cheapest"
                                    >
                                        <FaRupeeSign /> Lowest
                                    </label>
                                </Col>
                                <Col xs={12} className="text-center p-0">
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        id="fastest"
                                        checked={selectedSort === "fastest"}
                                        onChange={() => handleSortChange("fastest")}
                                    />
                                    <label
                                        className="btn btn-sm rounded-right fw-medium full-width d-flex align-items-center justify-content-center gap-1"
                                        htmlFor="fastest"
                                    >
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1em" height="1em" viewBox="0 0 128 128" enableBackground="new 0 0 128 128" xmlSpace="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path fill="#454545" d="M24,80H8.5v8H24c2.211,0,4-1.789,4-4S26.211,80,24,80z M27.23,41.574l-6.617,3.91 c0.18,0.637,0.461,1.246,0.961,1.746l11.313,11.313c1.563,1.566,4.094,1.566,5.656,0c1.566-1.563,1.566-4.094,0-5.656 L27.23,41.574z M60,28.531V44c0,2.211,1.789,4,4,4s4-1.789,4-4V28h-4L60,28.531z M100.77,41.574L89.457,52.887 c-1.566,1.563-1.566,4.094,0,5.656c1.563,1.566,4.094,1.566,5.656,0l10.699-10.699L100.77,41.574z M104,80c-2.211,0-4,1.789-4,4 s1.789,4,4,4h13.5v-8H104z"></path> </g> </g> <path fill="#000000" d="M64,24C30.863,24,4,50.863,4,84c0,7.023,1.27,13.734,3.488,20h113.023C122.73,97.734,124,91.023,124,84 C124,50.863,97.137,24,64,24z M52.93,96c1.656-4.621,5.875-8,11.07-8s9.414,3.379,11.07,8H52.93z M82.512,92.5l23.43-33.715 L72.57,82.008c0.098,0.047,0.18,0.117,0.273,0.164C70.172,80.828,67.195,80,64,80c-9.641,0-17.594,6.898-19.453,16H13.445 C12.484,92.031,12,88.016,12,84c0-28.672,23.328-52,52-52s52,23.328,52,52c0,4.016-0.484,8.031-1.445,12H83.453"></path> </g></svg>
                                        Fastest
                                    </label>
                                </Col>
                            </Row>
                        </div>
                    </div>


                    {filteredDataRoundTrip?.checkFlightType !== "INTERNATIONAL" &&
                        <div className="searchBar-single px-3 py-3 border-bottom">
                            <div className="searchBar-single-title d-flex mb-3">
                                <h6 className="sidebar-subTitle fs-6 fw-medium m-0">Return Popular Filter</h6>
                            </div>
                            <div className="searchBar-single-wrap">
                                <Row gutter={16} className="align-items-center justify-content-between">
                                    <Col xs={12} className="text-center pe-0">
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            id="cheapestReturn"
                                            checked={selectedSortReturn === "cheapestReturn"}
                                            onChange={() => handleSortReturnChange("cheapestReturn")}
                                        />
                                        <label
                                            className="btn btn-sm rounded-left fw-medium full-width d-flex align-items-center justify-content-center gap-1"
                                            htmlFor="cheapestReturn"
                                        >
                                            <FaRupeeSign /> Lowest
                                        </label>
                                    </Col>
                                    <Col xs={12} className="text-center p-0">
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            id="fastestReturn"
                                            checked={selectedSortReturn === "fastestReturn"}
                                            onChange={() => handleSortReturnChange("fastestReturn")}
                                        />
                                        <label
                                            className="btn btn-sm rounded-right fw-medium full-width d-flex align-items-center justify-content-center gap-1"
                                            htmlFor="fastestReturn"
                                        >
                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1em" height="1em" viewBox="0 0 128 128" enableBackground="new 0 0 128 128" xmlSpace="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path fill="#454545" d="M24,80H8.5v8H24c2.211,0,4-1.789,4-4S26.211,80,24,80z M27.23,41.574l-6.617,3.91 c0.18,0.637,0.461,1.246,0.961,1.746l11.313,11.313c1.563,1.566,4.094,1.566,5.656,0c1.566-1.563,1.566-4.094,0-5.656 L27.23,41.574z M60,28.531V44c0,2.211,1.789,4,4,4s4-1.789,4-4V28h-4L60,28.531z M100.77,41.574L89.457,52.887 c-1.566,1.563-1.566,4.094,0,5.656c1.563,1.566,4.094,1.566,5.656,0l10.699-10.699L100.77,41.574z M104,80c-2.211,0-4,1.789-4,4 s1.789,4,4,4h13.5v-8H104z"></path> </g> </g> <path fill="#000000" d="M64,24C30.863,24,4,50.863,4,84c0,7.023,1.27,13.734,3.488,20h113.023C122.73,97.734,124,91.023,124,84 C124,50.863,97.137,24,64,24z M52.93,96c1.656-4.621,5.875-8,11.07-8s9.414,3.379,11.07,8H52.93z M82.512,92.5l23.43-33.715 L72.57,82.008c0.098,0.047,0.18,0.117,0.273,0.164C70.172,80.828,67.195,80,64,80c-9.641,0-17.594,6.898-19.453,16H13.445 C12.484,92.031,12,88.016,12,84c0-28.672,23.328-52,52-52s52,23.328,52,52c0,4.016-0.484,8.031-1.445,12H83.453"></path> </g></svg>
                                            Fastest
                                        </label>
                                    </Col>

                                </Row>
                            </div>
                        </div>
                    }

                    <div className="searchBar-single px-3 py-3 border-bottom">
                        <div className="searchBar-single-title d-flex mb-3">
                            <h6 className="sidebar-subTitle fs-6 fw-medium m-0">Departure</h6>
                        </div>

                        <div className="searchBar-single-wrap">
                            <Row gutter={16} className="align-items-center justify-content-between">
                                <Col xs={12} className='text-center'>
                                    <input type="checkbox" className="btn-check" id="before_6AM" onChange={handleDepartureTimeChange} checked={selectedDeparture?.includes('before_6AM')} />
                                    <label className="btn rounded-1 fw-medium full-width mb-2" htmlFor="before_6AM">
                                        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 18H2M6.31412 12.3141L4.8999 10.8999M17.6858 12.3141L19.1 10.8999M22 18H20M7 18C7 15.2386 9.23858 13 12 13C14.7614 13 17 15.2386 17 18M22 22H2M16 6L12 2M12 2L8 6M12 2V9" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
                                        <br />
                                        Before 6AM</label>
                                </Col>
                                <Col xs={12} className='text-center'>
                                    <input type="checkbox" className="btn-check" id="after6AM_12PM" onChange={handleDepartureTimeChange} checked={selectedDeparture?.includes('after6AM_12PM')} />
                                    <label className="btn rounded-1 fw-medium  full-width mb-2" htmlFor="after6AM_12PM">
                                        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="12" r="5" stroke="#000000" strokeWidth="2"></circle> <path d="M12 2V4" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> <path d="M12 20V22" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> <path d="M4 12L2 12" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> <path d="M22 12L20 12" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> <path d="M19.7778 4.22266L17.5558 6.25424" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> <path d="M4.22217 4.22266L6.44418 6.25424" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> <path d="M6.44434 17.5557L4.22211 19.7779" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> <path d="M19.7778 19.7773L17.5558 17.5551" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> </g></svg>
                                        <br />
                                        6AM - 12PM</label>
                                </Col>
                                <Col xs={12} className='text-center'>
                                    <input type="checkbox" className="btn-check" id="after12PM_6PM" onChange={handleDepartureTimeChange} checked={selectedDeparture?.includes('after12PM_6PM')} />
                                    <label className="btn rounded-1 fw-medium full-width" htmlFor="after12PM_6PM">
                                        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 18H2M6.31412 12.3141L4.8999 10.8999M17.6858 12.3141L19.1 10.8999M22 18H20M7 18C7 15.2386 9.23858 13 12 13C14.7614 13 17 15.2386 17 18M22 22H2M16 5L12 9M12 9L8 5M12 9V2" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
                                        <br />
                                        12PM - 6PM</label>
                                </Col>
                                <Col xs={12} className='text-center'>
                                    <input type="checkbox" className="btn-check" id="after_6PM" onChange={handleDepartureTimeChange} checked={selectedDeparture?.includes('after_6PM')} />
                                    <label className="btn rounded-1 fw-medium full-width" htmlFor="after_6PM">
                                        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fillRule="evenodd" clipRule="evenodd" d="M11.0174 2.80157C6.37072 3.29221 2.75 7.22328 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C16.7767 21.25 20.7078 17.6293 21.1984 12.9826C19.8717 14.6669 17.8126 15.75 15.5 15.75C11.4959 15.75 8.25 12.5041 8.25 8.5C8.25 6.18738 9.33315 4.1283 11.0174 2.80157ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C12.7166 1.25 13.0754 1.82126 13.1368 2.27627C13.196 2.71398 13.0342 3.27065 12.531 3.57467C10.8627 4.5828 9.75 6.41182 9.75 8.5C9.75 11.6756 12.3244 14.25 15.5 14.25C17.5882 14.25 19.4172 13.1373 20.4253 11.469C20.7293 10.9658 21.286 10.804 21.7237 10.8632C22.1787 10.9246 22.75 11.2834 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z" fill="#000000"></path> </g></svg>
                                        <br />
                                        After 6PM</label>
                                </Col>
                            </Row>
                        </div>

                    </div>

                    {filteredDataRoundTrip?.checkFlightType !== "INTERNATIONAL" &&
                        <div className="searchBar-single px-3 py-3 border-bottom">
                            <div className="searchBar-single-title d-flex mb-3">
                                <h6 className="sidebar-subTitle fs-6 fw-medium m-0">Return</h6>
                            </div>
                            <div className="searchBar-single-wrap">
                                <Row gutter={16} className="align-items-center justify-content-between">
                                    <Col xs={12} className='text-center'>
                                        <input type="checkbox" className="btn-check" value="before_6AM" id="before_6AM_return" onChange={handleReturnDateChange} checked={selectedReturnDate?.includes('before_6AM')} />
                                        <label className="btn rounded-1 fw-medium full-width mb-2" htmlFor="before_6AM_return">
                                            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 18H2M6.31412 12.3141L4.8999 10.8999M17.6858 12.3141L19.1 10.8999M22 18H20M7 18C7 15.2386 9.23858 13 12 13C14.7614 13 17 15.2386 17 18M22 22H2M16 6L12 2M12 2L8 6M12 2V9" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
                                            <br />
                                            Before 6AM</label>
                                    </Col>
                                    <Col xs={12} className='text-center'>
                                        <input type="checkbox" className="btn-check" value="after6AM_12PM" id="after6AM_12PMreturn" onChange={handleReturnDateChange} checked={selectedReturnDate?.includes('after6AM_12PM')} />
                                        <label className="btn rounded-1 fw-medium  full-width mb-2" htmlFor="after6AM_12PMreturn">
                                            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="12" r="5" stroke="#000000" strokeWidth="2"></circle> <path d="M12 2V4" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> <path d="M12 20V22" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> <path d="M4 12L2 12" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> <path d="M22 12L20 12" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> <path d="M19.7778 4.22266L17.5558 6.25424" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> <path d="M4.22217 4.22266L6.44418 6.25424" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> <path d="M6.44434 17.5557L4.22211 19.7779" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> <path d="M19.7778 19.7773L17.5558 17.5551" stroke="#000000" strokeWidth="2" strokeLinecap="round"></path> </g></svg>
                                            <br />
                                            6AM - 12PM</label>
                                    </Col>
                                    <Col xs={12} className='text-center'>
                                        <input type="checkbox" className="btn-check" value="after12PM_6PM" id="after12PM_6PMreturn" onChange={handleReturnDateChange} checked={selectedReturnDate?.includes('after12PM_6PM')} />
                                        <label className="btn rounded-1 fw-medium full-width" htmlFor="after12PM_6PMreturn">
                                            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 18H2M6.31412 12.3141L4.8999 10.8999M17.6858 12.3141L19.1 10.8999M22 18H20M7 18C7 15.2386 9.23858 13 12 13C14.7614 13 17 15.2386 17 18M22 22H2M16 5L12 9M12 9L8 5M12 9V2" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
                                            <br />
                                            12PM - 6PM</label>
                                    </Col>
                                    <Col xs={12} className='text-center'>
                                        <input type="checkbox" className="btn-check" value="after_6PM" id="after_6PMreturn" onChange={handleReturnDateChange} checked={selectedReturnDate?.includes('after_6PM')} />
                                        <label className="btn rounded-1 fw-medium full-width" htmlFor="after_6PMreturn">
                                            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fillRule="evenodd" clipRule="evenodd" d="M11.0174 2.80157C6.37072 3.29221 2.75 7.22328 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C16.7767 21.25 20.7078 17.6293 21.1984 12.9826C19.8717 14.6669 17.8126 15.75 15.5 15.75C11.4959 15.75 8.25 12.5041 8.25 8.5C8.25 6.18738 9.33315 4.1283 11.0174 2.80157ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C12.7166 1.25 13.0754 1.82126 13.1368 2.27627C13.196 2.71398 13.0342 3.27065 12.531 3.57467C10.8627 4.5828 9.75 6.41182 9.75 8.5C9.75 11.6756 12.3244 14.25 15.5 14.25C17.5882 14.25 19.4172 13.1373 20.4253 11.469C20.7293 10.9658 21.286 10.804 21.7237 10.8632C22.1787 10.9246 22.75 11.2834 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z" fill="#000000"></path> </g></svg>
                                            <br />
                                            After 6PM</label>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    }
                    <div className="searchBar-single px-3 py-3 border-bottom">
                        <div className="searchBar-single-title d-flex mb-3">
                            <h6 className="sidebar-subTitle fs-6 fw-medium m-0">Pricing Range in (₹)</h6>
                        </div>

                        <div className="price-range-slider">
                            <div>
                                <Slider
                                    range
                                    min={minPrice}
                                    max={maxPrice}
                                    step={Math.ceil((priceRange[0] - priceRange[1]) / 100)}
                                    onChange={handlePriceRangeChange}
                                    value={priceRange}
                                    ariaLabelForHandle={['Minimum price slider', 'Maximum price slider']}
                                    ariaValueTextFormatterGroup={val => `₹${val}`}
                                />
                                <div className='price_box mt-3 mb-2 d-flex gap-2 align-items-center'>
                                    <div>
                                        <label id='minlabel'>Min Price</label>
                                        <p>₹{priceRange[0]}</p>
                                    </div>
                                    <div>
                                        <label id='maxlabel'>Max Price</label>
                                        <p>₹{priceRange[1]}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    {filteredDataRoundTrip?.checkFlightType !== "INTERNATIONAL" &&
                        <div className="searchBar-single px-3 py-3 border-bottom">
                            <div className="searchBar-single-title d-flex mb-3">
                                <h6 className="sidebar-subTitle fs-6 fw-medium m-0">Return Pricing Range in (₹)</h6>
                            </div>

                            <div className="price-range-slider">
                                <div>
                                    <Slider
                                        range
                                        min={returnMinPrice}
                                        max={returnMaxPrice}
                                        step={Math.ceil((returnPriceRange[0] - returnPriceRange[1]) / 100)}
                                        onChange={handleReturnPriceRangeChange}
                                        value={returnPriceRange}
                                        ariaLabelForHandle={['Minimum price slider', 'Maximum price slider']}
                                        ariaValueTextFormatterGroup={val => `₹${val}`}
                                    />

                                    <div className='price_box mt-3 mb-2 d-flex gap-2 align-items-center'>
                                        <div>
                                            <label id='minlabel'>Min Price</label>
                                            <p>₹{returnPriceRange[0]}</p>
                                        </div>
                                        <div>
                                            <label id='maxlabel'>Max Price</label>
                                            <p>₹{returnPriceRange[1]}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>}

                    <div className="searchBar-single px-3 py-3">
                        <div className="searchBar-single-title d-flex align-items-center justify-content-between mb-3">
                            <h6 className="sidebar-subTitle fs-6 fw-medium m-0">Preferred Airlines</h6>
                            {/* <a  className="text-md fw-medium text-muted active">Reset</a> */}
                        </div>
                        <div className="searchBar-single-wrap">
                            <Row gutter={16} className="align-items-center justify-content-between">

                                <Col xs={24}>
                                    <div className="form-check lg">
                                        {visibleAirlines?.map((item, index) => (
                                            <div className="frm-slicing d-flex align-items-center" key={index}>
                                                <Checkbox
                                                    checked={selectedAirlines.includes(item?.name)}
                                                    onChange={() => handleAirlineChange(item?.name)}
                                                />
                                                <div className="frm-slicing-end d-flex align-items-center justify-content-between full-width ps-1">
                                                    <div className="frms-flex d-flex align-items-center">
                                                        <img
                                                            className='img-collection result-flight mx-2'
                                                            style={{
                                                                width: "20px",
                                                                height: "20px"
                                                            }}
                                                            src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${item?.code}.gif`}
                                                            alt="logo"
                                                        />
                                                        <div className="frm-slicing-title">
                                                            <Tooltip title={item?.name}>
                                                                <span className="text-muted-2">{item?.name}</span>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                        {/* Conditionally show the "View All" / "View Less" button if items exceed 5 */}
                                        {roundCityFlightFilterData?.preferredAirlines?.length > maxVisibleItems && (
                                            <button className="read-more-button ms-3 text-decoration-none" onClick={toggleView} aria-label="view less">{showAll ? 'View Less' : 'View All'}</button>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </div>

                    </div>

                    <div className='d-md-none px-3 text-end mb-3'>
                        <button onClick={() => setIsVisibleRoundTrip(false)} className='w-100 py-3 btn btn-primary border-0 rounded text-decoration-none fs-5' aria-label="Apply">
                            Apply
                        </button>
                    </div>

                </div>





            </div>

        </>
    )
}

export default RoundTripFilter
